export const buildOpenAiResponsesLogsUrl = (runId: string): string => {
  const url = new URL('https://platform.openai.com/logs');
  url.searchParams.set('api', 'responses');
  url.searchParams.set('metadata[run_id]', runId);
  return url.toString();
};
